import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';

export const CenterWrapper = styled.section`
	overflow: hidden;
	display: flex;
	justify-content: center;
	flex: auto;
	flex-direction: column;
	height: 100vh;
	@media only screen and (max-width: 992px) {
		width: 100%;
		position: relative;
		display: block !important;
		height: 100%;
	}
	@media only screen and (min-width: 2000.99px) {
		display: block !important;
	}
`;
export const XPara1 = styled.div`
	color: ${({ theme }) => theme.colors.themeColor4};
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	@media only screen and (max-width: 768px) {
		font-size: 14px;
	}
`;
